// import { CalculatorOutlined, CopyOutlined } from '@ant-design/icons';
// import { Dropdown, Tooltip } from 'antd';
// import { useState, useEffect } from 'react';

// const Calculator = () => {
//   const [input, setInput] = useState('');
//   const [result, setResult] = useState('');

//   const handleClick = (value) => {
//     if (value === 'C') {
//       setInput('');
//       setResult('');
//     } else if (value === '⌫') {
//       setInput((prev) => prev.slice(0, -1));
//     } else if (value !== '=') {
//       setInput((prev) => prev + value);
//     }
//   };

//   useEffect(() => {
//     if (!input) {
//       setResult('');
//       return;
//     }

//     try {
//       const lastChar = input.trim().slice(-1);
//       if (!['+', '-', '*', '/'].includes(lastChar)) {
//         // eslint-disable-next-line no-eval
//         const evalResult = eval(input);
//         setResult(evalResult.toString());
//       }
//     } catch {
//       setResult('');
//     }
//   }, [input]);

//   const buttons = [
//     '7',
//     '8',
//     '9',
//     '/',
//     '4',
//     '5',
//     '6',
//     '*',
//     '1',
//     '2',
//     '3',
//     '-',
//     '0',
//     '.',
//     '=',
//     '+',
//     'C',
//     '⌫',
//   ];

//   return (
//     <div
//       style={{
//         width: 260,
//         padding: 16,
//         backgroundColor: '#fefefe',
//         borderRadius: 10,
//         boxShadow: '0 4px 20px rgba(0,0,0,0.1)',
//         fontFamily: 'monospace',
//       }}
//     >
//       <div
//         style={{
//           marginBottom: 12,
//           padding: '12px 10px',
//           border: '1px solid #ddd',
//           borderRadius: 8,
//           textAlign: 'right',
//           backgroundColor: '#fafafa',
//           minHeight: 70,
//           boxShadow: 'inset 0 1px 2px rgba(0,0,0,0.05)',
//           userSelect: 'none',
//           wordWrap: 'break-word',
//         }}
//       >
//         <div
//           style={{
//             fontSize: 18,
//             color: '#444',
//             fontWeight: '500',
//             marginBottom: 4,
//             wordBreak: 'break-word',
//           }}
//         >
//           {input || '0'}
//         </div>
//         {result !== '' && (
//           <div
//             style={{
//               display: 'flex',
//               alignItems: 'center',
//               justifyContent: 'space-between',
//               gap: 8,
//               fontSize: 22,
//               fontWeight: 'bold',
//               color: '#1677ff',
//               wordBreak: 'break-word',
//             }}
//           >
//             <span>= {result}</span>
//             <Tooltip title="Copy result">
//               <button
//                 onClick={() => navigator.clipboard.writeText(result)}
//                 style={{
//                   border: 'none',
//                   background: 'transparent',
//                   cursor: 'pointer',
//                   fontSize: 18,
//                   color: '#1677ff',
//                 }}
//               >
//                 <CopyOutlined />
//               </button>
//             </Tooltip>
//           </div>
//         )}
//       </div>

//       <div
//         style={{
//           display: 'grid',
//           gridTemplateColumns: 'repeat(4, 1fr)',
//           gap: 8,
//         }}
//       >
//         {buttons.map((btn) => (
//           <button
//             key={btn}
//             onClick={() => handleClick(btn)}
//             style={{
//               padding: '12px 0',
//               fontSize: 16,
//               borderRadius: 6,
//               border: 'none',
//               backgroundColor:
//                 btn === '='
//                   ? '#1677ff'
//                   : btn === 'C'
//                     ? '#ff4d4f'
//                     : btn === '⌫'
//                       ? '#ffa940'
//                       : '#f5f5f5',
//               color:
//                 btn === '=' || btn === 'C' || btn === '⌫' ? '#fff' : '#333',
//               cursor: 'pointer',
//               transition: 'all 0.2s ease',
//               boxShadow: '0 1px 3px rgba(0,0,0,0.05)',
//             }}
//             title={btn === '⌫' ? 'Delete one character' : undefined}
//           >
//             {btn}
//           </button>
//         ))}
//       </div>
//     </div>
//   );
// };

// const CalculatorApp = () => {
//   return (
//     <div>
//       <Dropdown
//         arrow={{ pointAtCenter: true }}
//         trigger={['click']}
//         popupRender={() => <Calculator />}
//       >
//         <Tooltip title="Calculator">
//           <CalculatorOutlined
//             style={{
//               fontSize: 28,
//               cursor: 'pointer',
//               padding: 8,
//               borderRadius: 6,
//               transition: 'background 0.2s',
//             }}
//           />
//         </Tooltip>
//       </Dropdown>
//     </div>
//   );
// };

// export default CalculatorApp;

import React, { useState, useEffect, useRef } from 'react';
import { CalculatorOutlined, CopyOutlined } from '@ant-design/icons';
import { Dropdown, Tooltip } from 'antd';

const Calculator = () => {
  const [input, setInput] = useState('');
  const [result, setResult] = useState('');
  const containerRef = useRef(null);

  const handleClick = (value) => {
    if (value === 'C') {
      setInput('');
      setResult('');
    } else if (value === '⌫') {
      setInput((prev) => prev.slice(0, -1));
    } else if (value === '=') {
      try {
        const evalResult = eval(input); // ⚠️ Replace eval in production
        setResult(evalResult.toString());
      } catch {
        setResult('Error');
      }
    } else {
      setInput((prev) => prev + value);
    }
  };

  useEffect(() => {
    const handleKeyDown = (e) => {
      const key = e.key;

      if (/[\d+\-*/.]/.test(key)) {
        setInput((prev) => prev + key);
      } else if (key === 'Enter') {
        e.preventDefault();
        try {
          const evalResult = eval(input);
          setResult(evalResult.toString());
        } catch {
          setResult('Error');
        }
      } else if (key === 'Backspace') {
        setInput((prev) => prev.slice(0, -1));
      } else if (key === 'Escape') {
        setInput('');
        setResult('');
      }
    };

    window.addEventListener('keydown', handleKeyDown);
    return () => window.removeEventListener('keydown', handleKeyDown);
  }, [input]);

  const buttons = [
    '7',
    '8',
    '9',
    '/',
    '4',
    '5',
    '6',
    '*',
    '1',
    '2',
    '3',
    '-',
    '0',
    '.',
    '=',
    '+',
    'C',
    '⌫',
  ];

  return (
    <div
      ref={containerRef}
      style={{
        width: 260,
        padding: 16,
        backgroundColor: '#fefefe',
        borderRadius: 10,
        boxShadow: '0 4px 20px rgba(0,0,0,0.1)',
        fontFamily: 'monospace',
      }}
    >
      <div
        style={{
          marginBottom: 12,
          padding: '12px 10px',
          border: '1px solid #ddd',
          borderRadius: 8,
          textAlign: 'right',
          backgroundColor: '#fafafa',
          minHeight: 70,
          boxShadow: 'inset 0 1px 2px rgba(0,0,0,0.05)',
          userSelect: 'none',
          wordWrap: 'break-word',
        }}
      >
        <div
          style={{
            fontSize: 18,
            color: '#444',
            fontWeight: '500',
            marginBottom: 4,
            wordBreak: 'break-word',
          }}
        >
          {input || '0'}
        </div>
        {result !== '' && (
          <div
            style={{
              display: 'flex',
              alignItems: 'center',
              justifyContent: 'space-between',
              gap: 8,
              fontSize: 22,
              fontWeight: 'bold',
              color: '#1677ff',
              wordBreak: 'break-word',
            }}
          >
            <span>= {result}</span>
            <Tooltip title="Copy result">
              <button
                onClick={() => navigator.clipboard.writeText(result)}
                style={{
                  border: 'none',
                  background: 'transparent',
                  cursor: 'pointer',
                  fontSize: 18,
                  color: '#1677ff',
                }}
              >
                <CopyOutlined />
              </button>
            </Tooltip>
          </div>
        )}
      </div>

      <div
        style={{
          display: 'grid',
          gridTemplateColumns: 'repeat(4, 1fr)',
          gap: 8,
        }}
      >
        {buttons.map((btn) => (
          <button
            key={btn}
            onClick={() => handleClick(btn)}
            style={{
              padding: '12px 0',
              fontSize: 16,
              borderRadius: 6,
              border: 'none',
              backgroundColor:
                btn === '='
                  ? '#1677ff'
                  : btn === 'C'
                    ? '#ff4d4f'
                    : btn === '⌫'
                      ? '#ffa940'
                      : '#f5f5f5',
              color:
                btn === '=' || btn === 'C' || btn === '⌫' ? '#fff' : '#333',
              cursor: 'pointer',
              transition: 'all 0.2s ease',
              boxShadow: '0 1px 3px rgba(0,0,0,0.05)',
            }}
            title={btn === '⌫' ? 'Delete one character' : undefined}
          >
            {btn}
          </button>
        ))}
      </div>
    </div>
  );
};

const CalculatorApp = () => {
  return (
    <div>
      <Dropdown
        arrow={{ pointAtCenter: true }}
        trigger={['click']}
        popupRender={() => <Calculator />}
        // dropdownRender={() => <Calculator />}
      >
        <Tooltip title="Calculator">
          <CalculatorOutlined
            style={{
              fontSize: 28,
              cursor: 'pointer',
              padding: 8,
              borderRadius: 6,
              transition: 'background 0.2s',
            }}
          />
        </Tooltip>
      </Dropdown>
    </div>
  );
};

export default CalculatorApp;
